import { render, staticRenderFns } from "./PickUpRecord.vue?vue&type=template&id=c4ed1634&scoped=true"
import script from "./PickUpRecord.vue?vue&type=script&lang=js"
export * from "./PickUpRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ed1634",
  null
  
)

export default component.exports